export const communityCoursesBlogPosts: { [key: string]: string } = {
  ar: 'https://www.memrise.com/ar/blog/changes-to-the-memrise-app',
  de: 'https://www.memrise.com/de/blog/changes-to-the-memrise-app',
  en: 'https://www.memrise.com/blog/changes-to-the-memrise-app',
  'en-us': 'https://www.memrise.com/blog/changes-to-the-memrise-app',
  es: 'https://www.memrise.com/es/blog/changes-to-the-memrise-app',
  'es-mx': 'https://www.memrise.com/es-mx/blog/changes-to-the-memrise-app',
  fr: 'https://www.memrise.com/fr/blog/changes-to-the-memrise-app',
  hi: 'https://www.memrise.com/hi/blog/changes-to-the-memrise-app',
  id: 'https://www.memrise.com/id/blog/changes-to-the-memrise-app',
  it: 'https://www.memrise.com/it/blog/changes-to-the-memrise-app',
  ja: 'https://www.memrise.com/ja/blog/changes-to-the-memrise-app',
  ko: 'https://www.memrise.com/ko/blog/changes-to-the-memrise-app',
  nl: 'https://www.memrise.com/nl/blog/changes-to-the-memrise-app',
  no: 'https://www.memrise.com/no/blog/changes-to-the-memrise-app',
  pl: 'https://www.memrise.com/pl/blog/changes-to-the-memrise-app',
  'pt-br': 'https://www.memrise.com/pt-br/blog/changes-to-the-memrise-app',
  ru: 'https://www.memrise.com/ru/blog/changes-to-the-memrise-app',
  sv: 'https://www.memrise.com/sv/blog/changes-to-the-memrise-app',
  tr: 'https://www.memrise.com/tr/blog/changes-to-the-memrise-app',
  vi: 'https://www.memrise.com/vi/blog/changes-to-the-memrise-app',
  'zh-cn': 'https://www.memrise.com/zh-hans/blog/changes-to-the-memrise-app',
  'zh-hant': 'https://www.memrise.com/zh-hant/blog/changes-to-the-memrise-app',
};

export const newExperienceBlogPosts: { [key: string]: string } = {
  ar: 'https://www.memrise.com/ar/blog/major-update-a-new-version-of-the-app-is-coming',
  de: 'https://www.memrise.com/de/blog/major-update-a-new-version-of-the-app-is-coming',
  en: 'https://www.memrise.com/blog/major-update-a-new-version-of-the-app-is-coming',
  es: 'https://www.memrise.com/es/blog/major-update-a-new-version-of-the-app-is-coming',
  'es-mx': 'https://www.memrise.com/es-mx/blog/major-update-a-new-version-of-the-app-is-coming',
  fr: 'https://www.memrise.com/fr/blog/major-update-a-new-version-of-the-app-is-coming',
  it: 'https://www.memrise.com/it/blog/major-update-a-new-version-of-the-app-is-coming',
  ja: 'https://www.memrise.com/ja/blog/major-update-a-new-version-of-the-app-is-coming',
  nl: 'https://www.memrise.com/nl/blog/major-update-a-new-version-of-the-app-is-coming',
  pl: 'https://www.memrise.com/pl/blog/major-update-a-new-version-of-the-app-is-coming',
  'pt-br': 'https://www.memrise.com/pt-br/blog/major-update-a-new-version-of-the-app-is-coming',
  ru: 'https://www.memrise.com/ru/blog/major-update-a-new-version-of-the-app-is-coming',
  tr: 'https://www.memrise.com/tr/blog/major-update-a-new-version-of-the-app-is-coming',
  vi: 'https://www.memrise.com/vi/blog/major-update-a-new-version-of-the-app-is-coming',
  'zh-cn': 'https://www.memrise.com/zh-hans/blog/major-update-a-new-version-of-the-app-is-coming',
  'zh-hant': 'https://www.memrise.com/zh-hant/blog/major-update-a-new-version-of-the-app-is-coming',
};
